import { FORM_IDS } from 'providers/PasswordResetProvider';
import { redirect } from 'react-router-dom';

// Generic Action Handler for Password Reset
// Used in PasswordReset.jsx and AcceptInvite.jsx
export async function handlePasswordResetAction(
  store,
  { params, request },
  apiEndpoint,
  errorMessage
) {
  try {
    const { employeeId, guid } = params ?? {};
    const formData = await request.formData();
    const password = formData.get(FORM_IDS.PASSWORD);
    const response = store.dispatch(
      apiEndpoint.initiate({
        employeeId,
        guid,
        password,
      })
    );

    const result = await response.unwrap();
    const { employeeSsoUrl: redirectUrl } = result ?? {};
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return { success: true, error: null };
    }

    return redirect('/');
  } catch (error) {
    const { data } = error ?? {};
    const { title: serverMessage } = data ?? {};

    return {
      success: false,
      error: serverMessage || errorMessage,
    };
  }
}
